import axios from 'axios';

class EtiquetaImpressaoService {
    async enviarDadosParaImpressora(dadosImpressao, portaGti, usaApplet) {
        var bodyFormData = new FormData();
        bodyFormData.append('documentData', dadosImpressao);

        if (usaApplet === "Z") {
            window.sendPrint(dadosImpressao);
        } else {
            return axios({
                method: 'post',
                url: `http://localhost:${portaGti}/gti-printer-proxy/api/printer/print`,
                data: bodyFormData,
                headers: {
                    'content-type': `application/x-www-form-urlencoded; boundary=${bodyFormData._boundary}`,
                }
            });
        }
    }
}

export default new EtiquetaImpressaoService();